import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  getAvailableWallets,
  hasWalletPaymentMethod
} from 'services/payment/paymentMethods'

import {getPaymentMethods, getPaymentRequestOptions} from '../selectors'

import type {PaymentMethodConfiguration} from 'services/payment/paymentMethods'
import type {RootState} from 'store'

export const resolveEnabledWallets = createAsyncThunk<
  PaymentMethodConfiguration[],
  void,
  {state: RootState}
>('paymentSettings/resolveEnabledWallets', async (_arg, {getState}) => {
  const state = getState()
  if (!hasWalletPaymentMethod(getPaymentMethods(state))) return []
  return getAvailableWallets(getPaymentRequestOptions(state))
})
